import React, { useEffect, useState, useCallback } from 'react';
import { Box, Container } from '@material-ui/core';
import {
  Section,
  useObservable,
  usePageTitle,
  usePropertyRoomTypes,
  ButtonLink,
} from '@lib/common';
import { sessionQuery } from '@lib/state';
import {
  getBulkChangeBillingQuery,
  getBulkChangeBillingService,
  GetBulkChangeBillingRunsRequest,
} from 'app/state';
import { BulkChangeBillingRunsFilter } from '../components';
import { BulkChangeBillingRunsList } from '../components';

export const BulkChangeBillingRunsPage: React.FC = () => {
  const propertyId = useObservable(sessionQuery.propertyId, 'async');
  const runs = useObservable(getBulkChangeBillingQuery().runs);
  const pagination = useObservable(getBulkChangeBillingQuery().pagination);
  const roomTypes = usePropertyRoomTypes(propertyId);
  const [filter, setFilter] = useState<GetBulkChangeBillingRunsRequest>({});

  usePageTitle('Bulk Change Billing Runs');

  useEffect(() => {
    if (propertyId) {
      getBulkChangeBillingService().getRuns({ propertyId, ...filter }, {});
    }
  }, [propertyId, filter]);

  const onFilterChange = useCallback((filters: GetBulkChangeBillingRunsRequest) => {
    setFilter(filters);
  }, []);

  const onLoadMore = useCallback(() => {
    if (propertyId && pagination?.continuationToken) {
      getBulkChangeBillingService().getRuns(
        { propertyId, ...filter },
        { continuationToken: pagination.continuationToken }
      );
    }
  }, [propertyId, filter, pagination]);

  if (!propertyId) return null;

  return (
    <Container maxWidth="xl">
      <Section disableGutters>
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <ButtonLink to="/bulk-change-billing/new" color="primary" variant="contained">
            New Bulk Change Billing
          </ButtonLink>
        </Box>
        <BulkChangeBillingRunsFilter
          filter={filter}
          roomTypes={roomTypes ?? []}
          onFilterChange={onFilterChange}
        />
        <BulkChangeBillingRunsList
          runs={runs ?? []}
          pagination={pagination}
          onLoadMore={onLoadMore}
        />
      </Section>
    </Container>
  );
};
